<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <div class="modal-title">
              <span>비밀번호 수정</span>
            </div>
            <div class="close">
              <i class="fal fa-times fa-fw" @click="closeModal"></i>
            </div>
          </slot>
        </div>
        <div class="modal-body">
          <div class="content">
            <FormulateForm #default="{ hasErrors }">
              <div>
                <div>기존</div>
                <FormulateInput
                  type="password"
                  error-behavior="value"
                  :validation="[['validateMinLength', 8]]"
                  v-model.trim="prePassword"
                  placeholder="현재 비밀번호"
                />
              </div>
              <div>
                <div>신규</div>
                <FormulateInput
                  type="toggable-password"
                  name="password"
                  v-model.trim="newPassword"
                  placeholder="영문/숫자 조합 10자 이상 입력"
                  error-behavior="value"
                  :validation="[['passwordValidation']]"
                  @blur="newPassword.replace(/\s/g, '')"
                />
              </div>
              <div class="btn-wrap">
                <button v-show="!loading" :disabled="hasErrors" @click="submit">
                  수정 완료
                </button>
                <button v-show="loading" disabled>
                  <i class="far fa-spinner fa-spin fa-fw"></i>
                </button>
              </div>
            </FormulateForm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="@/components/common/Table/index.css"></style>
<style src="./index.css" scoped></style>

<script>
/* eslint-disable */
export default {
  components: {},
  watch: {},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    async submit() {
      this.loading = true;
      if (this.isSameAsPrePassword()) {
        this.loading = false;
        return;
      }

      const changePasswordUrlByType =
        this.$store.getters["auth/tokenPayload"]().type === "manager"
          ? "users/biz_manager_changePassword"
          : "users/biz_member_changePassword";

      this.$store
        .dispatch(changePasswordUrlByType, {
          prePassword: this.prePassword,
          newPassword: this.newPassword
        })
        .then((result) => {
          if (result.code === 200) {
            alert("비밀번호 변경이 완료되었습니다.");
            this.closeModal();
          } else {
            const errorMessages = {
              404: "기존 비밀번호가 일치하지 않습니다.",
              401: "인증에러가 발생하였습니다.[401]",
              500: "서버에러가 발생하였습니다.[500]"
            };

            const alertMessage =
              errorMessages[result.code] ||
              `에러가 발생하였습니다[${result.code}]`;
            alert(alertMessage);
          }
        })
        .catch((e) => {
          console.error(e);
          alert("에러가 발생했습니다.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isSameAsPrePassword() {
      const isSame = this.newPassword === this.prePassword;
      if (isSame) {
        alert("신규 비밀번호는 기존 비밀번호와 다르게 입력해 주세요.");
      }
      return isSame;
    }
  },
  data() {
    return {
      loading: false,
      prePassword: "",
      newPassword: ""
    };
  },
  computed: {},
  async mounted() {}
};
</script>
